import React, { useState, useContext, useRef, useEffect, memo } from "react";
import PropTypes from "prop-types";
import Select from "react-select";
import { styles, navigateToCell } from "./shared.js";

export const RenderExceptionsEditable = memo(({
  value: initialValue,
  row,
  rowCount,
  column,
  onCellInputBlur,
  TableContext,
  viewOnly,
}) => {
  const exceptionsData = useContext(TableContext);
  const { index } = row;
  const { id } = column;
  const exceptionSelectRef = useRef(null);
  const [optionListIsOpen, setOptionListIsOpen] = useState(false);
  const [selectedValue, setSelectedValue] = useState(initialValue);

  useEffect(() => {
    setSelectedValue(initialValue);
  }, [initialValue]);

  useEffect(() => {
    if (optionListIsOpen) {
      const optionList = document.querySelector(`[role="listbox"]`);
      if (optionList) {
        // Calculate the position of the listbox bottom relative to the viewport
        if (optionList.getBoundingClientRect().bottom > window.innerHeight) {
          optionList.scrollIntoView({
            behavior: "smooth",
            block: "end",
            inline: "nearest",
          });
        }
      }
    }
  }, [optionListIsOpen]);

  return (
    <Select
      ref={exceptionSelectRef}
      placeholder={""}
      id={`${id}-${index}`}
      options={exceptionsData.exceptions.map((member) => ({
        label: member.code,
        value: member.code,
      }))}
      onMenuOpen={() => setOptionListIsOpen(true)}
      onMenuClose={() => setOptionListIsOpen(false)}
      value={
        selectedValue ? { label: selectedValue, value: selectedValue } : null
      }
      isDisabled={viewOnly}
      name="carss"
      myFontSize="5px"
      styles={styles}
      onChange={(e) => {
        setSelectedValue(e.value);
        onCellInputBlur(e.value, index, id, row);
      }}
      onKeyDown={(e) => {
        if (e.key === "Delete" || e.key === "Backspace") {
          setSelectedValue("");
          onCellInputBlur("", index, id, row);
        } else if (["ArrowUp", "ArrowDown", "ArrowLeft", "ArrowRight"].includes(e.key)) {
          e.preventDefault();
          navigateToCell(id, index, e.key, rowCount);
        }
      }}
    />
  );
});

RenderExceptionsEditable.displayName = "RenderExceptionsEditable";

RenderExceptionsEditable.propTypes = {
  value: PropTypes.string,
  row: PropTypes.shape({
    index: PropTypes.number.isRequired,
    original: PropTypes.shape({
      signOutComments: PropTypes.string,
    }).isRequired,
  }).isRequired,
  rowCount: PropTypes.number.isRequired,
  column: PropTypes.shape({
    id: PropTypes.string.isRequired,
  }).isRequired,
  onCellInputBlur: PropTypes.func.isRequired,
  TableContext: PropTypes.object.isRequired,
  viewOnly: PropTypes.bool.isRequired,
};
